// =====================================================================
// Chamados — SOLICITAÇÃO DE CHIP CELULAR: o espelho de tela (DEM-00027).
// =====================================================================
// ⚠️⚠️ ESTE ARQUIVO É ESPELHO de `server/chamados/atendimento/chamados-chip.js`,
//    e existe porque o front (Create React App) NÃO importa de `server/`. Mudou
//    um, muda o outro — há teste travando (`server/tests/espelhos-back-front.test.js`,
//    par do Chip). Divergir não dá erro em lugar nenhum: o sintoma é a tela
//    oferecer um motivo que o servidor recusa, ou pedir a linha atual num motivo
//    em que ela não faz sentido.
//
// ⚠️ AUTOCONTIDO DE PROPÓSITO — nada de `import` aqui. É o que permite ao teste
//    do backend carregá-lo dentro do Jest (que é CommonJS).
//
// ⚠️ O que NÃO vem para cá: a validação inteira (`validarPedidoChip`). A tela
//    valida o que evita ida-e-volta; a REGRA é do servidor.
// =====================================================================

/** O nome do tipo, EXATO como está na lista do servidor (com acento e cedilha). */
export const TIPO_CHIP = 'Solicitação de Chip Celular';

/**
 * Os motivos → rótulo legível (espelho do `ROTULO_MOTIVO` do servidor).
 * ⚠️ As CHAVES são o CÓDIGO que o banco grava (o `ENUM`); o texto é só rótulo.
 */
// ⚠️ Três motivos oferecidos (Julia, 29/09). O `ENUM` da coluna tem um quarto
//    valor dormente (`SEGUNDA_VIA`) que o app não oferece — ver `chamados-chip.js`.
export const ROTULO_MOTIVO = {
  NOVO: 'Chip novo',
  TROCA: 'Troca de chip',
  CANCELAMENTO: 'Cancelamento',
};

/** Os motivos como `{ valor, rotulo }`, para o `<select>` da tela. */
export const MOTIVOS_CHIP = Object.entries(ROTULO_MOTIVO).map(([valor, rotulo]) => ({ valor, rotulo }));

/** Os motivos que EXIGEM a linha/número atual (espelho do servidor). */
export const MOTIVOS_EXIGEM_LINHA = ['TROCA', 'CANCELAMENTO'];

/**
 * Os rótulos PRÓPRIOS dos status DENTRO da aba de chip.
 * ⚠️ O chip reusa 'Atribuido'/'Encerrado', mas para a loja eles são
 *    'Aguardando Fernanda' e 'Concluída'. Lido só na aba de chip.
 */
export const ROTULO_STATUS_CHIP = {
  Atribuido: 'Aguardando Fernanda',
  Encerrado: 'Concluída',
  Cancelado: 'Cancelada',
};

/** O chamado é um pedido de chip? Casamento exato, como no servidor. */
export function ehChip(tipo) {
  return String(tipo || '') === TIPO_CHIP;
}

/** O motivo exige a linha atual? Recebe o CÓDIGO. */
export function motivoExigeLinha(motivo) {
  return MOTIVOS_EXIGEM_LINHA.includes(String(motivo || ''));
}
